import type { TimeInTrade } from '../types'

/** "45 min", "5 h", "8.5 h", "1.8 days": the unit a reader thinks in. */
export const formatHours = (hours: number): string => {
  if (hours < 1) return `${Math.max(1, Math.round(hours * 60))} min`
  if (hours < 48) return `${hours < 10 ? Number(hours.toFixed(1)) : Math.round(hours)} h`
  return `${(hours / 24).toFixed(1)} days`
}

/** "median 5 h in trade (mean 10.5 h)", or null with nothing to say. */
export const timeInTradeLine = (t: TimeInTrade | null | undefined): string | null =>
  t && t.n > 0 && t.median_hours != null && t.mean_hours != null
    ? `median ${formatHours(t.median_hours)} in trade (mean ${formatHours(t.mean_hours)})`
    : null
